export enum typesNotifications {
    Leido = 'R',
    NoLeido = 'N',
    Todo = '',
    Borrado = 'E'
}